<!--
作業・生産記録詳細画面
URL：/product/detail/:uid
表示条件：ログイン済みであること
-->

<template>
  <div>
    <v-row>
      <v-container fill-height>
        <v-col style="height: 0px"></v-col>
      </v-container>
    </v-row>
    <alert :errors="errors" css_class="ma-1"></alert>
    <record-date-picker
      :events="events"
      @on-update-search-date="onUpdateSearchDate"
      @on-update-calendar-month="onUpdateCalendarEvent"
    >
      <template #prefix>
        作業記録：{{ displayName }}
      </template></record-date-picker
    >
    <v-divider class="ml-3 mr-3"></v-divider>
    <div>
      <record-detail
        :title="item.title"
        :schema="item.schema"
        :json="item.json"
        v-for="item in data"
        :key="item.key"
        @pushMessage="showMessage"
      ></record-detail>
    </div>
  </div>
</template>

<script>
import RecordDatePicker from "../../components/product-records/record-date-picker.vue";
import RecordDetail from "../../components/product-records/record-detail.vue";
import SeaWater from "../../logic/parser/seawater";
import Shipping from "../../logic/parser/shipping";
import Unloading from "../../logic/parser/unloading";
import Worklog from "../../logic/parser/worklog";
import Alert from "../../components/common/alert.vue";
import Api from "@/logic/api/api.js";
import DateWrapper from "../../logic/common/date-wrapper";
import AlertContents from "@/logic/common/alert-contents.js";
export default {
  components: {
    "record-date-picker": RecordDatePicker,
    "record-detail": RecordDetail,
    alert: Alert,
  },
  data() {
    let displayName = "-";
    let requireGetName = true;

    const userList = this.$store.getters.haccpUserList;
    const user = this.getUser(userList, this.$route.params.uid);
    if (user) {
      displayName = user.userName || "-";
      requireGetName = false;
    }

    this.applyDataToDailyArea(Date.now(), requireGetName);
    return {
      displayName: displayName,
      data: [],
      errors: [],
      events: {},
    };
  },
  methods: {
    onUpdateSearchDate(searchDate) {
      this.applyDataToDailyArea(searchDate, false);
    },
    onUpdateCalendarEvent(searchDate) {
      this.applyDataToMonthlyArea(searchDate);
    },
    applyDataToDailyArea(date, requireUserInfo = false) {
      const { apiList, mapping } = this.haccpInfoRequest({
        date: new DateWrapper(date),
        daily: true,
        requireUserInfo: requireUserInfo,
      });

      this.$nextTick(() => {
        // APIのリクエスト
        this.$store.commit("setWaiting", true);
        Promise.all(apiList)
          .then((result) => {
            this.$store.commit("setWaiting", false);
            if ("user" in mapping) {
              this.displayName =
                this.getUser(result[mapping.user].users, this.$route.params.uid)
                  ?.display_name || "-";
            }
            this.data = [
              {
                title: "作業記録",
                json: result[mapping.worklog].record_list,
                schema: Worklog,
              },
              {
                title: "水揚げ",
                json: result[mapping.unloading].record_list,
                schema: Unloading,
              },
              {
                title: "加工・出荷",
                json: result[mapping.shipping].record_list,
                schema: Shipping,
              },
              {
                title: "使用海水",
                json: result[mapping.seawater].record_list,
                schema: SeaWater,
              },
            ];
          })
          .catch((error) => {
            this.$store.commit("setWaiting", false);
            this.data = [];
            if (error.status == 403) {
              if (this.errors.length == 0) {
                this.errors.push(AlertContents.error("権限がありません"));
              }
            } else {
              Api.resolve(error);
            }
          });
      });
    },
    applyDataToMonthlyArea(date) {
      const { apiList, mapping } = this.haccpInfoRequest({
        date: new DateWrapper(date),
        daily: false,
        requireUserInfo: false,
      });

      this.$nextTick(() => {
        // APIのリクエスト
        this.$store.commit("setWaiting", true);
        Promise.all(apiList)
          .then((result) => {
            this.$store.commit("setWaiting", false);
            this.events = {
              unloading: result[mapping.unloading].record_list.map(
                (item) => new DateWrapper(item.record_date).format.systemDate
              ),
              shipping: result[mapping.shipping].record_list.map(
                (item) => new DateWrapper(item.record_date).format.systemDate
              ),
              seawater: result[mapping.seawater].record_list.map(
                (item) => new DateWrapper(item.record_date).format.systemDate
              ),
              worklog: result[mapping.worklog].record_list.map(
                (item) => new DateWrapper(item.record_date).format.systemDate
              ),
            };
          })
          .catch((error) => {
            this.$store.commit("setWaiting", false);
            this.data = [];
            if (error.status == 403) {
              if (this.errors.length == 0) {
                this.errors.push(AlertContents.error("権限がありません"));
              }
            } else {
              Api.resolve(error);
            }
          });
      });
    },

    getUser(user, uid) {
      const users = user.filter((user) => user.uid == uid);
      if (users.length >= 1) {
        return users[0];
      }
      return null;
    },

    haccpInfoRequest(parameter) {
      const date = parameter["date"] || new DateWrapper(Date.now());
      const daily = parameter["daily"] || false;
      const requireUserInfo = parameter["requireUserInfo"] || false;

      let requestDate = {
        year: date.format.build((d) => new String(d.date.y)),
        month: date.format.build((d) => new String(d.date.m02)),
      };
      if (daily) {
        requestDate["day"] = date.format.build((d) => new String(d.date.d02));
      }
      var apiList = [];
      var keys = [];
      if (requireUserInfo) {
        keys.push("user");
        apiList.push(
          Api.call("/admin/user", {
            purpose: "VIEW_HACCP",
          })
        );
      }
      keys.push(...["worklog", "shipping", "unloading", "seawater"]);
      apiList.push(
        ...[
          Api.call("/work/record", {
            uid: this.$route.params.uid,
            record_type: "WORKLOG",
            record_date: requestDate,
          }),
          Api.call("/haccp/record", {
            uid: this.$route.params.uid,
            record_type: "SHIPPING",
            record_date: requestDate,
          }),
          Api.call("/haccp/record", {
            uid: this.$route.params.uid,
            record_type: "UNLOADING",
            record_date: requestDate,
          }),
          Api.call("/haccp/record", {
            uid: this.$route.params.uid,
            record_type: "SEAWATER",
            record_date: requestDate,
          }),
        ]
      );
      return {
        apiList: apiList,
        mapping: keys.reduce((map, key, index) => {
          map[key] = index;
          return map;
        }, {}),
      };
    },
    /**
     * エラーメッセージをクリアする
     */
    clearMessage() {
      this.errors = [];
    },
    /**
     * エラーメッセージを表示する
     */
    showMessage(error) {
      this.clearMessage();
      this.errors.push(error);
      window.scrollTo(0, 0);
    },
  },
};
</script>

<style scope>
hr {
  border-color: indigo !important;
}
</style>
